/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */
/**
 * These properties are set on map layers that are managed by Abc-Map
 */
export var LayerProperties;
(function (LayerProperties) {
    /**
     * Unique identifier of layer
     */
    LayerProperties["Id"] = "abc:layer:id";
    /**
     * Readable name of layer
     */
    LayerProperties["Name"] = "abc:layer:name";
    /**
     * If true, user modifications are applied on this layer
     */
    LayerProperties["Active"] = "abc:layer:active";
    /**
     * Type of layer
     */
    LayerProperties["Type"] = "abc:layer:type";
    /**
     * If set, this Openlayers layer is managed by Abc-Map
     */
    LayerProperties["Managed"] = "abc:layer:managed";
    /**
     * This property is set on layer collection in order to trigger changes
     */
    LayerProperties["LastLayerChange"] = "abc:layers:last-change";
    LayerProperties["StyleOptions"] = "abc:layers:style-options";
})(LayerProperties || (LayerProperties = {}));
/**
 * These properties are set on map layers, but are specific to predefined layers
 */
export var PredefinedLayerProperties;
(function (PredefinedLayerProperties) {
    /**
     * Contains layer model, for persistence
     */
    PredefinedLayerProperties["Model"] = "abc:layer:predefined:model";
})(PredefinedLayerProperties || (PredefinedLayerProperties = {}));
export var WmsLayerProperties;
(function (WmsLayerProperties) {
    WmsLayerProperties["Urls"] = "abc:layer:wms:urls";
    WmsLayerProperties["RemoteLayerName"] = "abc:layer:wms:remote-layer-name";
    WmsLayerProperties["Username"] = "abc:layer:wms:username";
    WmsLayerProperties["Password"] = "abc:layer:wms:password";
    WmsLayerProperties["Projection"] = "abc:layer:wms:projection";
    WmsLayerProperties["Extent"] = "abc:layer:wms:extent";
})(WmsLayerProperties || (WmsLayerProperties = {}));
export var WmtsLayerProperties;
(function (WmtsLayerProperties) {
    WmtsLayerProperties["CapabilitiesUrl"] = "abc:layer:wmts:capabilities-url";
    WmtsLayerProperties["LayerName"] = "abc:layer:wmts:layer-name";
    WmtsLayerProperties["Username"] = "abc:layer:wmts:username";
    WmtsLayerProperties["Password"] = "abc:layer:wmts:password";
})(WmtsLayerProperties || (WmtsLayerProperties = {}));
export var XyzLayerProperties;
(function (XyzLayerProperties) {
    XyzLayerProperties["Url"] = "abc:layer:xyz:url";
    XyzLayerProperties["Projection"] = "abc:layer:xyz:projection";
    XyzLayerProperties["MinZoom"] = "abc:layer:xyz:min-zoom";
    XyzLayerProperties["MaxZoom"] = "abc:layer:xyz:max-zoom";
})(XyzLayerProperties || (XyzLayerProperties = {}));
//# sourceMappingURL=LayerProperties.js.map